import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth } from "../../firebase";

import { useState } from "react";
import { deleteProfilePhoto } from "../../utils/indexedDB";

export default function Register({
  setSection,
  sidebarTheme,
  clearForcedTheme,
}) {
  const isMobile = window.matchMedia("(max-width: 600px)").matches;

  const s = styles(sidebarTheme, isMobile);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  /* ===== EMAIL SIGNUP ===== */
  async function handleRegister() {
    setError("");
    setLoading(true);

    try {
      const cred = await createUserWithEmailAndPassword(auth, email, password);

      await sendEmailVerification(cred.user);
      await auth.signOut(); // 🔥 VERY IMPORTANT
      setSection("login");
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  }

  /* ===== GOOGLE SIGNUP ===== */
  async function handleGoogleSignup() {
    setError("");
    setLoading(true);

    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      clearForcedTheme();
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  }

  return (
    <div style={s.overlay}>
      <div style={s.page}>
        <h1 style={s.title}>Create Account</h1>
        <button style={s.googleBtn} onClick={handleGoogleSignup}>
          Continue with Google
        </button>
        <div style={s.divider}>OR</div>
        <input
          style={s.input}
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          style={s.input}
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <div style={s.error}>{error}</div>}
        <button
          style={s.primaryBtn}
          onClick={handleRegister}
          disabled={loading}
        >
          Create Account
        </button>
        <p style={s.terms}>
          By signing up, you agree to our{" "}
          <span style={s.link} onClick={() => setSection("terms-auth")}>
            Terms and Conditions
          </span>
        </p>
        <p style={s.switch}>
          Already registered?{" "}
          <span style={s.link} onClick={() => setSection("login")}>
            Sign in
          </span>
        </p>
        <div style={{ marginTop: 18, textAlign: "center" }}>
          <button
            onClick={async () => {
              await deleteProfilePhoto(); // ✅ ADD THIS LINE
              localStorage.setItem("onboardingDone", "true");
              setSection("practice");
            }}
            style={{
              background: "transparent",
              border: "none",
              color: sidebarTheme.accent,
              fontWeight: 700,
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Continue as Guest
          </button>
        </div>
      </div>
    </div>
  );
}

/* ===== STYLES (THEME AWARE) ===== */
const styles = (theme, isMobile) => ({
  overlay: {
    position: "fixed",
    inset: 0,

    background: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(24px)",

    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",

    overflowY: "auto",
    overflowX: "hidden", // 🔥 PREVENT LEFT–RIGHT SCROLL
    padding: "16px 0",
  },
  page: {
    width: "100%",
    maxWidth: 420,
    margin: "0 16px",
    padding: isMobile ? 16 : 24,

    boxSizing: "border-box", // ✅ optional safety

    textAlign: "center",
    background: theme.card,
    borderRadius: isMobile ? 12 : 14,
    border: `1px solid ${theme.border}`,
    color: theme.text,
  },

  title: {
    fontSize: isMobile ? 24 : 32,
    fontWeight: 800,
    marginBottom: isMobile ? 18 : 24,
  },

  input: {
    width: "100%",
    boxSizing: "border-box", // 🔥 THIS IS THE KEY FIX

    padding: isMobile ? "14px 14px" : "12px 14px",
    marginBottom: 12,

    borderRadius: 8,
    border: `1px solid ${theme.border}`,
    background: theme.bgMain,
    color: theme.text,
    outline: "none",
    fontSize: isMobile ? 15 : 14,
  },

  primaryBtn: {
    width: "100%",
    padding: isMobile ? 14 : 12,
    borderRadius: 10,
    border: "none",
    background: theme.accentGradient,
    color: "#fff",
    fontWeight: 600,
    fontSize: isMobile ? 15 : 14,
    cursor: "pointer",
  },

  googleBtn: {
    width: "100%",
    padding: isMobile ? 14 : 12,
    borderRadius: 10,
    border: `1px solid ${theme.border}`,
    background: "transparent",
    color: theme.text,
    fontWeight: 600,
    fontSize: isMobile ? 15 : 14,
    cursor: "pointer",
    marginBottom: 14,
  },

  divider: {
    margin: "20px 0",
    opacity: 0.6,
  },

  error: {
    color: theme.danger,
    marginBottom: 10,
  },

  link: {
    color: theme.accent,
    cursor: "pointer",
    fontWeight: 600,
  },

  terms: {
    fontSize: isMobile ? 12 : 13,
    marginTop: 14,
    opacity: 0.8,
  },

  switch: {
    marginTop: 18,
    fontSize: isMobile ? 13 : 14,
  },
});
